<template>
    <div class="vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="showfaktur">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Tanggungan</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page">
            <div class="p-x-20 p-y-16 w-limit f-16 f-ln-150">
                Anda bisa memasukkan pembayaran tanggungan oleh karyawan yang akan memotong gajinya.
            </div>
            <div class="separator"></div>
            <div class="kasbon-wrapper p-t-16 p-d-20 p-x-20 w-limit">

                <!-- KASBON -->
                <div class="f-16 f-bold">Tanggungan Kasbon</div>
                <div class="m-t-16 m-d-20 kasbon-contents f-ln-150">

                    <div class="item-kasbon" v-for="ListKasbonFaktur in datalisttanggungan.kasbonfaktur"
                         :key="ListKasbonFaktur.id" @click="showmodalkasbon(ListKasbonFaktur)">
                        <div class="item-kasbon--left">
                            <div class="f-16">{{ListKasbonFaktur.keterangan}}</div>
                            <div class="f-13 f-c-midgrey">{{ListKasbonFaktur.waktukasbon}} • {{ ListKasbonFaktur.saldo |
                                currency }}
                            </div>
                        </div>
                        <div class="item-kasbon--right">
                            <img src="../../../assets/icons/chevron_right_4.svg" alt="">
                        </div>
                    </div>

                </div>
            </div>

            <div class="separator"></div>

            <!-- POTONGAN -->
            <div class="potongan-wrapper p-t-16 p-d-20 p-x-20 w-limit">
                <div class="f-16 f-bold">Tanggungan Potongan</div>
                <div class="m-t-16 m-d-20 kasbon-contents f-ln-150">

                    <div class="item-potongan" @click="showmodalpotongan(ListPotonganFaktur)"
                         v-for="ListPotonganFaktur in datalisttanggungan.potonganfaktur" :key="ListPotonganFaktur.id">
                        <div class="item-potongan--left">
                            <div class="f-16">{{ListPotonganFaktur.keterangan}}
                            </div>
                            <div class="f-13 f-c-midgrey">{{ListPotonganFaktur.waktupotongan}} • {{
                                ListPotonganFaktur.saldo | currency }}
                            </div>
                        </div>
                        <div class="item-potongan--right">
                            <img src="../../../assets/icons/chevron_right_4.svg" alt="">
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="modal fade" id="modalnotifPotongan" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-head w-limit">
                        <div class="modal-head--left"></div>
                        <h5 class="f-16 f-bold">Pembayaran Potongan</h5>
                        <div class="modal-head--right" data-dismiss="modal">
                            <img src="../../../assets/img/x2.svg" alt="">
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="modal-bodyy w-limit w-100 p-x-20">
                        <div class="p-y-16">
                            <div class="f-16 f-semi m-d-4">{{potongan.keterangan}}</div>
                            <div class="f-16">{{ potongan.saldo | currency()}}</div>
                        </div>
                        <div class="separator-line-dot"></div>
                        <div class="m-t-16">

                            <label class="form-label">Jenis Pembayaran</label>
                            <div class="radio-group">
                                <div class="radio-wrapper">
                                    <div class="radio-item">
                                        <input type="radio" id="potonganlunas" :value="1" name="radioboxxpotongan"
                                               v-model="formPotongan.type">
                                        <label for="potonganlunas">Lunas</label>
                                    </div>
                                    <div class="radio-item">
                                        <input type="radio" id="potongancicil" :value="2" name="radioboxxpotongan"
                                               v-model="formPotongan.type">
                                        <label for="potongancicil">Cicilan</label>
                                    </div>
                                </div>
                            </div>

                            <label class="m-t-16 form-label">Nominal</label>
                            <InputRupiah
                                    :style="(formPotongan.type===2) ? '' : 'display: none'"
                                    :outerDivClass="'input-group mod'"
                                    v-model="formPotongan.nominal"
                                    innerDivClass="input-group-prepend"
                                    :showRp="true"
                                    :defaultValue="formPotongan.nominal.formatted"
                            />
                            <div class="input-group mod" v-if="formPotongan.type!==2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Rp</span>
                                </div>
                                <input type="text" class="form-control" id="inputsaldopotonganfaktur" disabled
                                       :value="newrupiahcreateepaymentnominal(potongan.saldo)">
                            </div>


                            <div class="button-wrapper m-t-4 p-y-20 w-limit w-100">
                                <button class="btn smart-primary" @click="BayarPotongan">Tambahkan</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalnotifKasbon" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-head w-limit">
                        <div class="modal-head--left"></div>
                        <h5 class="f-16 f-bold">Pembayaran Kasbon</h5>
                        <div class="modal-head--right" data-dismiss="modal">
                            <img src="../../../assets/img/x2.svg" alt="">
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="modal-bodyy w-limit w-100 p-x-20">
                        <div class="p-y-16">
                            <div class="f-16 f-semi m-d-4">{{kasbon.keterangan}}</div>
                            <div class="f-16">{{ kasbon.saldo | currency()}}</div>
                        </div>
                        <div class="separator-line-dot"></div>
                        <div class="m-t-16">

                            <label class="form-label">Jenis Pembayaran</label>
                            <div class="radio-group">
                                <div class="radio-wrapper">
                                    <div class="radio-item">
                                        <input type="radio" id="kasbonlunas" :value="1" name="radioboxxkasbon"
                                               v-model="formKasbon.type">
                                        <label for="kasbonlunas">Lunas</label>
                                    </div>
                                    <div class="radio-item">
                                        <input type="radio" id="kasboncicil" :value="2" name="radioboxxkasbon"
                                               v-model="formKasbon.type">
                                        <label for="kasboncicil">Cicilan</label>
                                    </div>
                                </div>
                            </div>

                            <label class="m-t-16 form-label">Nominal</label>
                            <InputRupiah
                                    :style="(formKasbon.type===2) ? '' : 'display: none'"
                                    :outerDivClass="'input-group mod'"
                                    v-model="formKasbon.nominal"
                                    innerDivClass="input-group-prepend"
                                    :showRp="true"
                                    :defaultValue="formKasbon.nominal.formatted"
                            />
                            <div class="input-group mod" v-if="formKasbon.type!==2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Rp</span>
                                </div>
                                <input type="text" class="form-control" id="inputsaldokasbonfaktur" disabled
                                       :value="newrupiahcreateepaymentnominal(kasbon.saldo)">
                            </div>


                            <div class="button-wrapper m-t-4 p-y-20 w-limit w-100">
                                <button class="btn smart-primary" @click="BayarKasbon">Tambahkan</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ErrorMessage from "@/component-items/ErrorMessage";
    import InputRupiah from "@/component-items/InputRupiah";

    export default {
        name: 'ListTanggungan',
        props: ['datalisttanggungan', 'datalisttanggungan_absen'],
        components: {ErrorMessage, InputRupiah},
        data() {
            return {
                kasbon: {
                    id: "",
                    keterangan: "",
                    saldo: ""
                },
                formKasbon: {
                    type: 0,
                    nominal: {
                        raw: 0,
                        formatted: ""
                    }
                },
                potongan: {
                    id: "",
                    keterangan: "",
                    saldo: ""
                },
                formPotongan: {
                    type: 0,
                    nominal: {
                        raw: 0,
                        formatted: ""
                    }
                },
            }
        },
        mounted() {

        },
        methods: {
            newrupiahcreateepaymentnominal(angka, prefix) {

                /* Fungsi formatRupiah */
                var number_string = angka.toString().replace(/[^.\d]/g, ""),
                    split = number_string.split("."),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            showfaktur() {
                this.$emit('back')
            },


            findPembayaranKasbonById(id) {
                var pembayaran_kasbon = this.datalisttanggungan.pembayaran_kasbon;
                for (let i = 0; i < pembayaran_kasbon.length; i++) {
                    if (pembayaran_kasbon[i].kasbon.id === id) {
                        return [pembayaran_kasbon[i], i];
                    }
                }
                return null;
            },

            findPembayaranPotonganById(id) {
                var pembayaran_potongan = this.datalisttanggungan.pembayaran_potongan;
                for (let i = 0; i < pembayaran_potongan.length; i++) {
                    if (pembayaran_potongan[i].potongan.id === id) {
                        return [pembayaran_potongan[i], i];
                    }
                }
                return null;
            },


            showmodalkasbon(kasbon) {
                var pembayaranKasbonExist = this.findPembayaranKasbonById(kasbon.id);
                var nominalBayar = (pembayaranKasbonExist != null) ? pembayaranKasbonExist[0].nominal : 0;
                var typeBayar = (pembayaranKasbonExist != null) ? pembayaranKasbonExist[0].type : 1;
                this.kasbon = kasbon
                this.formKasbon.type = typeBayar
                this.formKasbon.nominal = {
                    raw: nominalBayar,
                    formatted: this.newrupiahcreateepaymentnominal(nominalBayar)
                }
                $('#modalnotifKasbon').modal('show');
                // this.checkvalidateBtnkasbon();
            },


            showmodalpotongan(potongan) {
                var pembayaranKasbonExist = this.findPembayaranPotonganById(potongan.id);
                var nominalBayar = (pembayaranKasbonExist != null) ? pembayaranKasbonExist[0].nominal : 0;
                var typeBayar = (pembayaranKasbonExist != null) ? pembayaranKasbonExist[0].type : 1;
                this.potongan = potongan
                this.formKasbon.type = typeBayar
                this.formKasbon.nominal = {
                    raw: nominalBayar,
                    formatted: this.newrupiahcreateepaymentnominal(nominalBayar)
                }
                $('#modalnotifPotongan').modal('show');
                // this.checkvalidateBtnpotongan();
            },


            BayarKasbon() {
                if (this.formKasbon.type === 2) {
                    if (this.formKasbon.nominal.raw > this.kasbon.saldo) {
                        this.$toast.error("Pembayaran kasbon tidak boleh melebihi sisa kasbon.")
                        return
                    }
                }

                var pembayaranKasbonExist = this.findPembayaranKasbonById(this.kasbon.id);
                let pembayaran_kasbon = {
                    kasbon: this.kasbon,
                    type: this.formKasbon.type,
                    nominal: {
                        raw:(this.formKasbon.type === 2) ? this.formKasbon.nominal.raw : this.kasbon.saldo,
                        formatted:(this.formKasbon.type === 2) ? this.formKasbon.nominal.formatted : this.newrupiahcreateepaymentnominal(this.kasbon.saldo)
                    },
                    status: 1,
                };
                if (pembayaranKasbonExist === null) {
                    this.datalisttanggungan.pembayaran_kasbon.push(pembayaran_kasbon);
                } else {
                    this.datalisttanggungan.pembayaran_kasbon[pembayaranKasbonExist[1]] = pembayaran_kasbon;
                }
                $('#modalnotifKasbon').modal('hide');

                this.showfaktur();
            },


            BayarPotongan() {
                if (this.formPotongan.type === 2) {
                    if (this.formPotongan.nominal.raw > this.potongan.saldo) {
                        this.$toast.error("Pembayaran potongan tidak boleh melebihi sisa potongan.")
                        return
                    }
                }

                var pembayaranPotonganExist = this.findPembayaranPotonganById(this.potongan.id);
                let pembayaran_potongan = {
                    potongan: this.potongan,
                    type: this.formPotongan.type,
                    nominal: {
                        raw:(this.formPotongan.type === 2) ? this.formPotongan.nominal.raw : this.potongan.saldo,
                        formatted:(this.formPotongan.type === 2) ? this.formPotongan.nominal.formatted : this.newrupiahcreateepaymentnominal(this.potongan.saldo)
                    },
                    status: 1,
                };
                
                if (pembayaranPotonganExist === null) {
                    this.datalisttanggungan.pembayaran_potongan.push(pembayaran_potongan);
                } else {
                    this.datalisttanggungan.pembayaran_potongan[pembayaranPotonganExist[1]] = pembayaran_potongan;
                }
                $('#modalnotifPotongan').modal('hide');

                this.showfaktur();
            },


        }
    }
</script>

<style>
    .item-kasbon,
    .item-potongan {
        border: 1px solid #C8D0DD;
        padding: 8px 18px;
        border-radius: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
    }

    .item-potongan--left,
    .item-kasbon--left {
        overflow: hidden;
    }

    .item-potongan--left .f-16,
    .item-kasbon--left .f-16 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .item-kasbon:last-child,
    .item-potongan:last-child {
        margin-bottom: 0px;
    }
</style>